import { Icon, type IconGlyphProps } from 'BomdisoftComponents/icons/base';
import { CONTENT_COPY_GLYPH } from 'BomdisoftComponents/icons/glyphs';

export const ContentCopyIcon = (props: IconGlyphProps) => <Icon {...props} glyph={CONTENT_COPY_GLYPH} />;
